import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

/* utilidades */
const toArray = (v) => (Array.isArray(v) ? v : v ? Object.values(v) : []);
const mealsOrder = [
  "desayuno",
  "comida",
  "cena",
  "colacion1",
  "colacion2",
  "colacion3",
];

const addMacros = (obj, acc) => {
  acc.c += +obj.carbohidratos || 0;
  acc.p += +obj.proteinas || 0;
  acc.l += +obj.lipidos || 0;
  acc.e += +obj.energiaKcal || 0;
};

const DietChart = ({
  dietasAsignadas,
  selectedDay,
  accentColor = "#2563eb",
}) => {
  if (!dietasAsignadas?.length) {
    return <Typography>No hay dietas asignadas</Typography>;
  }

  const dieta = dietasAsignadas[0];
  const diasObject = dieta?.dias?.[0] || {};
  const dayData = diasObject[selectedDay];

  if (!dayData) {
    return (
      <Typography>
        No hay datos para <b>{selectedDay}</b>
      </Typography>
    );
  }

  /* --- calcular macros SUMANDO suplementos --- */
  const acum = { c: 0, p: 0, l: 0, e: 0 };
  (dayData.alimentosDia || []).forEach((slot) =>
    mealsOrder.forEach((mealKey) => {
      (slot[mealKey]?.contenido || []).forEach((item) => {
        if (item.ingrediente) addMacros(item.ingrediente, acum);
        if (item.suplemento) addMacros(item.suplemento, acum);
        if (item.platillo) {
          if (item.platillo.necesidades)
            addMacros(item.platillo.necesidades, acum);
          else
            toArray(item.platillo.ingredientes).forEach((ing) =>
              addMacros(ing, acum)
            );
        }
      });
    })
  );

  /* fallback a valores ya guardados si no se obtuvo nada */
  const carbs =
    acum.c ||
    (dayData.carbohidratos ? Number(dayData.carbohidratos.toFixed(2)) : 0);
  const prot =
    acum.p || (dayData.proteinas ? Number(dayData.proteinas.toFixed(2)) : 0);
  const lip =
    acum.l || (dayData.lipidos ? Number(dayData.lipidos.toFixed(2)) : 0);
  const kcal =
    acum.e ||
    (dayData.energiaKcal ? Number(dayData.energiaKcal.toFixed(2)) : 0);

  const palette = [accentColor, "#0ea5e9", "#f97316"];

  const data = {
    labels: ["Carbohidratos (g)", "Proteínas (g)", "Lípidos (g)"],
    datasets: [
      {
        label: "Distribución Nutricional",
        data: [carbs, prot, lip],
        backgroundColor: palette.map((color) => `${color}99`),
        borderColor: palette,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: { usePointStyle: true },
      },
      title: {
        display: true,
        text: `Distribución Nutricional - ${selectedDay}`,
        font: { size: 16, weight: "bold" },
      },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `${ctx.label}: ${ctx.parsed?.toFixed?.(2) ?? ctx.parsed}`,
        },
      },
    },
  };

  return (
    <Box sx={{ maxWidth: 360, mx: "auto" }}>
      <Pie data={data} options={options} />
      <Typography align="center" sx={{ mt: 1 }}>
        Energía total: <b>{kcal.toFixed(2)} kcal</b>
      </Typography>
    </Box>
  );
};

export default DietChart;
